module.exports = __webpack_public_path__ + "img/16129835922.DITP.a4309cdc.svg";